module.exports = __webpack_public_path__ + "static/media/marketplace.46a49c6c.svg";